import { render, staticRenderFns } from "./iDalgo-Liveblog-Viewer.vue?vue&type=template&id=4979ad67"
import script from "./iDalgo-Liveblog-Viewer.vue?vue&type=script&lang=js"
export * from "./iDalgo-Liveblog-Viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports